(() => {
  if (customElements.get('atelier-product-section')) return;
  const desktop = window.matchMedia('(min-width: 750px)');
  const attached = new Map();
  const modernRows = [];
  const isModern = () => document.body.dataset.contentLayout === 'modern';
  let running = false;
  let frame;
  let removeScrollMode = () => {};

  function restore() {
    for (const row of modernRows.splice(0)) {
      while (row.firstChild) row.before(row.firstChild);
      row.remove();
    }
    document.querySelectorAll('.atelier-modern-image, .atelier-modern-image-right').forEach(el => el.classList.remove('atelier-modern-image', 'atelier-modern-image-right'));
    for (const [id, { source, panel, wasHidden }] of attached) {
      const current = document.getElementById(id);
      if (current === source) {
        const marker = source.querySelector('atelier-product-section');
        while (panel.firstChild) source.insertBefore(panel.firstChild, marker);
        source.hidden = wasHidden;
      }
      panel.remove();
    }
    attached.clear();
    document.querySelectorAll('.atelier-has-attached-sections').forEach(product => {
      product.classList.remove('atelier-has-attached-sections');
    });
  }

  function enableScrollMode(product) {
    if (isModern() || !window.matchMedia('(min-width: 990px)').matches || product.dataset.independentScroll !== 'true') return;
    const header = document.getElementById('atelier-header-group');
    const galleryColumn = product.querySelector('.product__media-wrapper');
    // Native page scrolling: the left column pins without copying scroll offsets.
    const measure = () => {
      const headerHeight = header?.getBoundingClientRect().height || 0;
      product.style.setProperty('--product-pin-top', `${headerHeight + 16}px`);
      product.style.setProperty('--product-gallery-height', `${galleryColumn?.getBoundingClientRect().height || 0}px`);
      product.style.setProperty('--product-scroll-height', `${Math.max(320, window.innerHeight - headerHeight - 40)}px`);
    };
    product.classList.add('atelier-independent-scroll', 'atelier-native-scroll');
    header?.classList.add('atelier-browser-scroll-header');
    const observer = new ResizeObserver(measure);
    if (header) observer.observe(header);
    if (galleryColumn) observer.observe(galleryColumn);
    window.addEventListener('resize', measure, { passive: true });
    measure();
    removeScrollMode = () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
      product.classList.remove('atelier-independent-scroll', 'atelier-native-scroll');
      header?.classList.remove('atelier-browser-scroll-header');
      product.style.removeProperty('--product-pin-top');
      product.style.removeProperty('--product-gallery-height');
      product.style.removeProperty('--product-scroll-height');
    };
  }

  function arrange() {
    frame = null;
    running = true;
    try {
    removeScrollMode();
    removeScrollMode = () => {};
    restore();
    const product = document.querySelector('#MainContent product-info[id^="MainProduct-"]');
    const root = product?.closest('.shopify-section');
    const column = product?.querySelector('.product__info-wrapper');
    const gallery = product?.querySelector('.atelier-gallery-group') || product?.querySelector('.product__media-wrapper');
    if (desktop.matches && root && column && !product.querySelector('.product--no-media')) {
      let section = root.nextElementSibling;
      while (section) {
        // App-injected siblings are not content sections and must not break assignment.
        if (!section.classList.contains('shopify-section')) { section = section.nextElementSibling; continue; }
        if (!section.querySelector('atelier-product-section')) break;
        const next = section.nextElementSibling;
        const marker = section.querySelector('atelier-product-section');
        if (isModern() && marker.dataset.column !== 'gallery') { section = next; continue; }
        const target = marker.dataset.column === 'gallery' ? gallery : column;
        const panel = document.createElement('div');
        panel.id = section.id.replace('shopify-section-', 'atelier-assigned-');
        panel.className = 'atelier-attached-section atelier-layout-ready';
        const wasHidden = section.hidden;
        for (const child of [...section.childNodes]) {
          if (child !== marker) panel.append(child);
        }
        attached.set(section.id, { source: section, panel, wasHidden });
        section.hidden = true;
        target.append(panel);
        section = next;
      }
      product.classList.toggle('atelier-has-attached-sections', attached.size > 0);
    }
    if (gallery) {
      gallery.style.removeProperty('--gallery-sticky-top');
      if (desktop.matches && product.dataset.independentScroll !== 'true') {
        const media = product.querySelector('.product__media-wrapper');
        const initialTop = media.getBoundingClientRect().top + window.scrollY;
        const availableTop = Math.max(24, window.innerHeight - gallery.offsetHeight - 24);
        gallery.style.setProperty('--gallery-sticky-top', `${Math.max(24, Math.min(initialTop, availableTop))}px`);
      }
    }
    if (product && column) {
      enableScrollMode(product);
    }
    if (isModern()) arrangeModern();
    document.querySelectorAll('atelier-product-section').forEach(marker => marker.closest('.shopify-section')?.classList.add('atelier-layout-ready'));
    } finally {
      running = false;
    }
  }

  function arrangeModern() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const sections = [...main.children].filter(el => el.classList.contains('shopify-section') && !el.hidden);
    let imageIndex = 0;
    let previousPanel = null;
    for (const section of sections) {
      if (section.querySelector('.image-with-text')) {
        section.classList.add('atelier-modern-image');
        section.classList.toggle('atelier-modern-image-right', imageIndex++ % 2 === 0);
      }
      if (section.querySelector('.atelier-comparison, .atelier-situations')) {
        if (previousPanel) {
          const row = document.createElement('div');
          row.className = 'atelier-modern-pair page-width';
          previousPanel.before(row);
          row.append(previousPanel, section);
          modernRows.push(row);
          previousPanel = null;
        } else previousPanel = section;
      } else previousPanel = null;
    }
  }

  function schedule() {
    if (!running && !frame) frame = requestAnimationFrame(arrange);
  }
  customElements.define('atelier-product-section', class extends HTMLElement {
    connectedCallback() { schedule(); }
  });
  desktop.addEventListener('change', schedule);
  // Mobile browser chrome changes height during scroll, not the layout width.
  let layoutWidth = window.innerWidth;
  let resizeTimer;
  window.addEventListener('resize', () => {
    if (window.innerWidth === layoutWidth) return;
    layoutWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(schedule, 120);
  }, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('product-info:loaded', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('shopify:section:select', event => {
    const record = attached.get(event.target.id);
    record?.panel.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  });
  // Wait until Shopify has finished replacing or removing the section.
  document.addEventListener('shopify:section:unload', schedule);
  // Complete the layout after parsing, and restore it when returning from page cache.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
  schedule();
})();
